
import { Component, Emit, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class extends Vue {
  @Prop()
  public value!: string;

  @Emit()
  public input(value: string): string {
    return value;
  }

  private created() {
    const query = this.$route.query;
    this.localValue = query.search ? decodeURI(query.search as string) : "";
  }

  private get localValue(): string {
    return this.value;
  }

  private set localValue(value: string) {
    this.input(value);
  }
}
